export const fieldSetterHandler = (setter) => (newValue) => {
  setter(newValue);
};

export default fieldSetterHandler;
